import { FilteredCreditApplication, PHONE_NUMBER_IFINANCE, PHONE_NUMBER_LINK_IFINANCE, PageSectionTitle as SectionTitle } from '@applyonline/shared'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useTrackStepReachedEvent } from '../../../../services/trackingEvents'
import { ETrackingEvent } from '../../../../types/tracking'

interface Props {
  creditApp: FilteredCreditApplication
}

const DeclinedPrequalForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  useTrackStepReachedEvent(creditApp, ETrackingEvent.PrequalDeclined)

  return (
    <main className="general-message" style={{ textAlign: 'center' }}>
      <SectionTitle title={t('common.financeApplication')} />
      <p>
        <Trans
          i18nKey="finalDecision.refused"
          values={{
            phoneNumber: PHONE_NUMBER_IFINANCE,
          }}
          components={{
            a: <Link to={PHONE_NUMBER_LINK_IFINANCE} style={{ textWrap: 'nowrap', textDecoration: 'underline' }} />,
          }}
        />
      </p>
    </main>
  )
}

export default DeclinedPrequalForm
